import { Link } from "react-router-dom";
import logoVerde from "@/assets/logo-verde.webp";

export const Footer = () => {
  return (
    <footer className="bg-foreground text-background py-12">
      <div className="container">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <img src={logoVerde} alt="Aceena" className="h-9 w-auto" />
          <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6 text-sm text-background/50">
            <p>© {new Date().getFullYear()} Aceena.</p>
            <Link
              to="/politica-de-privacidade"
              className="hover:text-aceena-green transition-colors"
            >
              Política de Privacidade
            </Link>
            <Link
              to="/termos-de-uso"
              className="hover:text-aceena-green transition-colors"
            >
              Termos de Uso
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
